import state from './retention.state'
import mutations from './retention.mutations'
import actions from './retention.actions'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
